export default __webpack_public_path__ + "static/media/moto.c07ab628.svg";